import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { configJSON } from '../appURLConfig';
import {
  UserCSVModel,
  UserCSVResponseModel,
  UserModel,
  UserPageRequest,
} from '../common/models/userModel';


@Injectable({
  providedIn: 'root',
})
export class UsersService {
  adminUserList: UserModel[];
  constructor(private http: HttpClient) {}

  /** One batch of client users; the request carries the cursor, sort and search terms. */
  getUserList(req: UserPageRequest): Observable<any> {
    return this.http.post(configJSON.getUserData, req, {withCredentials: true});
  }

  /** A single user, for the edit popup. */
  getUser(userGuid: string): Observable<any> {
    return this.http.post(configJSON.getUserByGuid, { userGuid }, {withCredentials: true});
  }

  /** Resolves email addresses to users for the CSV upload, matched in the database. */
  getUsersByEmail(emailAddresses: string[]): Observable<any> {
    return this.http.post(configJSON.getUsersByEmail, { emailAddresses }, {withCredentials: true});
  }

  getAdminList(req: any): Observable<any> {
    return this.http.post(configJSON.getAdminUserListCatalog, req,{withCredentials: true});
  }

  addEditAdmin( data: any ): Observable<any> {
    return this.http.post(configJSON.addUpdateAdminUserCatalog , data,{withCredentials: true});
  }

  validateUser(userId: string) {
    const req = { encryptedUserId: userId };
    return this.http.post(configJSON.getUserVerification, req,{withCredentials: true});
  }

  /** Saves only the rows that were actually changed. */
  saveChangesUserdata(data: UserModel[] ): Observable<any> {
    return this.http.post(configJSON.saveUserData, data,{withCredentials: true});
  }

  sendEmail(data: UserCSVModel[]): Observable<UserCSVResponseModel> {
    return this.http.post<UserCSVResponseModel>(configJSON.sendEmail , data,{withCredentials: true});
  }
}
